var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51.5789,
    height: 51.5789,
    rx: 17.193,
    fill: "#316FF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.638 25.7895C41.638 17.0359 34.5418 9.9397 25.7883 9.9397C17.0347 9.9397 9.93848 17.0359 9.93848 25.7895C9.93848 34.5431 17.0347 41.6393 25.7883 41.6393C34.5418 41.6393 41.638 34.5431 41.638 25.7895Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.901 29.9616L31.5624 28.0177C30.0699 26.5252 27.4096 29.8937 27.4022 29.9012C27.1947 30.1079 25.5276 28.7766 24.1643 27.414C22.8009 26.0514 21.4704 24.3836 21.6771 24.1761C21.6853 24.1687 25.0538 21.5091 23.5606 20.0159L21.6204 17.6773C19.5258 15.852 12.9881 20.8114 21.745 29.5713L21.8779 29.7034L22.0107 29.837C30.7639 38.5939 35.7263 32.0577 33.901 29.9616Z",
    fill: "#316FF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneLogo);
export default __webpack_public_path__ + "static/media/phone_logo.48c1ad6b966c68b146884635e720e0e2.svg";
export { ForwardRef as ReactComponent };